/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
import {Route, Switch} from 'react-router';
// structure
import Division from 'material/structure/division/division';
import Body from 'material/structure/body/body_container';
// pages
import RequestDemo from 'pages/auth/requestdemo/requestdemo_container';
import RequestSubmitted from 'pages/auth/requestsubmitted/requestsubmitted_container';
import CompleteSignUp from 'pages/auth/completesignup/completesignup_container';
import SignIn from 'pages/auth/signin/signin_container';
import ResetPassword from 'pages/auth/resetpassword/resetpassword_container';
import PasswordReset from 'pages/auth/passwordreset/passwordreset_container';
import PasswordUpdated from 'pages/auth/passwordupdated/passwordupdated_container';
import CompletePasswordReset from 'pages/auth/completepasswordreset/completepasswordreset_container';
// material
import Logo from 'material/graphic/logo/logo';
import Link from 'material/ctas/link/link_container';
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/auth/auth_styles';


/* ========== ~~~~~~~~~~ AUTH : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const Auth = (props) => {
    return(
        <Division name={`auth`} klass={`${props.classes.auth}`}>
            <header>
                <Link type={`external`} action={`${url.company}`}><Logo name={`insticator`} text={`Insticator`} /></Link>
            </header>
            <Body>
                <Switch>
                    {/*Routes to subsections*/}
                    <Route path='/auth/requestdemo' component={RequestDemo} />
                    <Route path='/auth/requestsubmitted' component={RequestSubmitted} />
                    <Route path='/auth/completesignup' component={CompleteSignUp} />
                    <Route path='/auth/signin' component={SignIn} />
                    <Route path='/auth/resetpassword' component={ResetPassword} />
                    <Route path='/auth/passwordreset' component={PasswordReset} />
                    <Route path='/auth/passwordupdated' component={PasswordUpdated} />
                    <Route path='/auth/completepasswordreset' component={CompletePasswordReset} />
                </Switch>
            </Body>
        </Division>
    );
};

// TODO Uncomment requestsubmitted and completesignup when product is ready.


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(Auth);